/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_ad__magazine__generic_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Entdecken Sie unsere Reisetipps im Magazine`
};

const en_ad__magazine__generic_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Check out our travel tips and let the Magazine guide you`
};

const es_ad__magazine__generic_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Descubre nuestros consejos de viaje y déjate guiar por el Magazine`
};

const fr_ad__magazine__generic_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Découvrez nos conseils de voyage et laissez-vous guider avec Le Mag`
};

const it_ad__magazine__generic_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Scopri i nostri consigli di viaggio e lasciati guidare da Magazine`
};

const nl_ad__magazine__generic_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Ontdek onze reistips en laat u leiden door het Magazine`
};

const pt_ad__magazine__generic_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Descubra os nossos conselhos de viagem e deixe-se guiar pelo Magazine`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ad__magazine__generic_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ad__magazine__generic_subtitle", locale)
	if (locale === "de") return de_ad__magazine__generic_subtitle(inputs)
	if (locale === "en") return en_ad__magazine__generic_subtitle(inputs)
	if (locale === "es") return es_ad__magazine__generic_subtitle(inputs)
	if (locale === "fr") return fr_ad__magazine__generic_subtitle(inputs)
	if (locale === "it") return it_ad__magazine__generic_subtitle(inputs)
	if (locale === "nl") return nl_ad__magazine__generic_subtitle(inputs)
	return pt_ad__magazine__generic_subtitle(inputs)
};